/* eslint-disable react/display-name */
import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Icon } from 'react-native-elements';
import Projects from './screens/Admin/Projects';
import ToolStack from './screens/Admin/ToolStack';
import HiaManager from './screens/Admin/HiaManager';
import Report from './screens/Admin/Report';
import HospitalManager from './screens/Admin/HospitalManager';

export type AdminTabParamList = {
	Report: undefined;
	Projects: undefined;
	Tools: undefined;
	HIA: undefined;
	Hospitals: undefined;
	Users: undefined;
};

const BottomTab = createBottomTabNavigator<AdminTabParamList>();

export default function AdminTab(): JSX.Element {
	return (
		<BottomTab.Navigator
			screenOptions={({ route }) => ({
				tabBarIcon: (options): React.ReactNode => {
					const { size, color } = options;
					let iconName = 'home';
					if (route.name == 'Report') iconName = 'bar-chart-2';
					if (route.name == 'Projects') iconName = 'activity';
					if (route.name == 'Tools') iconName = 'command';
					if (route.name == 'Users') iconName = 'users';
					if (route.name == 'HIA') iconName = 'shield';
					if (route.name == 'Hospitals') iconName = 'plus-square';

					// You can return any component that you like here!
					return <Icon type="feather" name={iconName} size={size + 10} color={color} />;
				},
			})}
			tabBarOptions={{
				activeTintColor: '#275036',
				inactiveTintColor: 'gray',
				labelPosition: 'below-icon',
				labelStyle: { fontWeight: '700' },
				style: { height: '8%' },
			}}
		>
			<BottomTab.Screen name="Report" component={Report} />
			<BottomTab.Screen name="Projects" component={Projects} />
			<BottomTab.Screen name="Tools" component={ToolStack} />
			<BottomTab.Screen name="HIA" component={HiaManager} />
			<BottomTab.Screen name="Hospitals" component={HospitalManager} />
			{/* <BottomTab.Screen name="Users" component={HiaManager} /> */}
		</BottomTab.Navigator>
	);
}
